import { render, staticRenderFns } from "./AudioEmbed.vue?vue&type=template&id=6ab4c7c0&"
import script from "./AudioEmbed.vue?vue&type=script&lang=js&"
export * from "./AudioEmbed.vue?vue&type=script&lang=js&"
import style0 from "./AudioEmbed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports